import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LocationCollection } from '../../shared/locations/location.model';

const API_URL = environment.apiUrl;
const CMS_API_URL = environment.cmsApiUrl;

@Injectable({
  providedIn: 'root', // Automatically registers the service globally
})
export class ComunicationService {
  constructor(private http: HttpClient) {}

  public sendConfirmationEmail(maker): Observable<object> {
    return this.http.post<any>(API_URL + '/user_email_confirmation', maker);
  }
}
